import React, { useState } from 'react';
import classNames from 'classnames'; // Upewnij się, że masz zaimportowane
import css from './SubscriptionChat.css';

const SubscriptionChat = ({ messages, onSend, isSending, isProvider, intl }) => {
  const [text, setText] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (text.trim()) {
      onSend(text);
      setText('');
    }
  };

  return (
    <div className={css.chatWrapper}>
      <div className={css.messageList}>
        {messages?.map(msg => {
          // Logika identyfikacji: czy ja to wysłałem?
          const sentByMe = isProvider 
            ? msg.attributes.sender === 'provider' 
            : msg.attributes.sender === 'customer';

          return (
            // Kluczowa zmiana: Dodajemy klasę css.otherMessage, jeśli wiadomość nie jest moja
            <div key={msg.id.uuid} className={classNames(css.messageRow, { [css.otherMessage]: !sentByMe })}>
              <div className={css.messageContent}>
                <div className={css.meta}>
                  <span className={sentByMe ? css.authorMe : css.authorOther}>
                    {sentByMe ? 'Ty' : (isProvider ? 'Klient' : 'Partner')}
                  </span>
                  <span className={css.date}>
                    {intl.formatDate(msg.attributes.createdAt, { hour: '2-digit', minute: '2-digit' })}
                  </span>
                </div>
                <div className={css.text}>{msg.attributes.text}</div>
              </div>
            </div>
          );
        })}
      </div>

      <form onSubmit={handleSubmit} className={css.quickSend}>
        <input
          className={css.input}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Napisz wiadomość..."
        />
        <button type="submit" className={css.inlineBtn} disabled={isSending || !text.trim()}>
          {isSending ? '...' : 'Wyślij'}
        </button>
      </form>
    </div>
  );
};

export default SubscriptionChat;